import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const ES6Promise = require("es6-promise");
ES6Promise.polyfill();
const axios = require('axios');
import staticUrl from "RNExamsbookCommon/constants/staticUrl";
export const baseUrl = Platform.OS === 'web' ? '/' : staticUrl.BASE_URL;
//base URL.
let instance = axios.create({
    baseURL: baseUrl
});

// Alter defaults after instance has been created
instance.defaults.headers.common['language'] = 'en';

//request interceptor
instance.interceptors.request.use(async function (config) {
    // Do something before request is sent
    if (Platform.OS === 'web') {
        //workaround as localStorage wont work in react native.
        try {
            config.headers.language = getLanguage();
        } catch (e) {
            console.log('localstorage not found---->>>', e);
        }
    } else {
        //it is non web plateform. so it must be mobile.
        const lang = await AsyncStorage.getItem('USER_LANGUAGE', lang, ()=>{});
        config.headers.language = lang || 'en';
        const userToken = await AsyncStorage.getItem('USER_AUTH_TOKEN');
        const orgId = await AsyncStorage.getItem('ORG_ID');
        if (userToken) {
            config.headers.Authorization = 'Bearer ' + userToken;
        }
        
        if (orgId) {
            config.headers.organization = orgId;
        }
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error.response);
});
//response interceptor
instance.interceptors.response.use((response) => {
    return response;
}, function (error) {
    // Do something with response error
    if (error && error.response && error.response.status === 401) {
        //if web then logout.
        if (Platform.OS === 'web') {
            console.log('unauthorized, logging out ...', error.response);
            window.location.href = '/log-in?return_to=/my-app';
        }
        //TODO handle mobile app logout.
    }
    return Promise.reject(error.response);
});

function getLanguage() {
    return localStorage.getItem('langugae');
}
export default instance;
